import React, { FC } from 'react';
import classNames from 'classnames';

export type FilterSwitchState = '' | 'neutral' | 'mixed' | 'include' | 'exclude' | 'some-included' | 'some-excluded';
type Props = {
    filterState: FilterSwitchState;
    onFilterChange: (state: 'include' | 'exclude') => void;
};

export const FilterSwitch: FC<Props> = ({ filterState, onFilterChange }) => {
    const mainClasses = classNames('slide-control', {
        excluded: filterState === 'exclude',
        included: filterState === 'include',
        'sub-only': filterState === 'some-included' || filterState === 'mixed',
        'sub-excl': filterState === 'some-excluded' || filterState === 'mixed'
    });

    return (
        <span className={mainClasses} aria-label="filter-switch">
            <a
                className="sc-section sc-section-only"
                data-cy="filter-only"
                onClick={() => onFilterChange('include')}
                aria-label="include"
            />
            <a
                className="sc-section sc-section-excl"
                data-cy="filter-excl"
                onClick={() => onFilterChange('exclude')}
                aria-label="exclude"
            />
        </span>
    );
};
